import { render, staticRenderFns } from "./ConflictsRegistry.vue?vue&type=template&id=7e8bc3d7&"
import script from "./ConflictsRegistry.vue?vue&type=script&lang=ts&"
export * from "./ConflictsRegistry.vue?vue&type=script&lang=ts&"
import style0 from "./ConflictsRegistry.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports